<template>
    <div class="row">
        <div class="col-lg-12">
            <b-card class="bg-default-card no-padding">
                <b-tabs card v-model="invoiceShowTabState">
                    <b-tab :title="uLang('app.sales_invoices')" v-if="$can('index-sales-invoices')">
                        <sales-invoices-tab />
                    </b-tab>
                    <b-tab :title="uLang('app.buy_invoices')" v-if="$can('index-buy-invoices')">
                        <buy-invoices-tab />
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
    import { SalesInvoicesTab, BuyInvoicesTab } from '~/components/tabs'

    export default {
        name: 'Invoices',

        components: {
            SalesInvoicesTab,
            BuyInvoicesTab,
        },
        data() {
            return {
                invoiceShowTabState: 0
            }
        },
        created() {
            const type = this.$route.query.type;
            if (type === 'buy_invoice') {
                this.invoiceShowTabState = 1;
            }
        },
    }
</script>

<style lang="css" scoped>

</style>
